export interface LanguageProfile {
  locale: string;
  direction: 'ltr' | 'rtl';
  alphabet: string[];
}

export const english: LanguageProfile = {
  locale: 'en', direction: 'ltr', alphabet: [...'ABCDEFGHIJKLMNOPQRSTUVWXYZ'],
};

export const spanish: LanguageProfile = {
  locale: 'es', direction: 'ltr', alphabet: [...'ABCDEFGHIJKLMNÑOPQRSTUVWXYZÁÉÍÓÚÜ'],
};
export const dictionaryVersion = (locale: string): string => locale === 'es' ? 'wordhuli-es-curated-v1' : 'wordnet-3.0-curated-v1';

export function graphemes(value: string, locale = 'en'): string[] {
  return [...new Intl.Segmenter(locale, { granularity: 'grapheme' }).segment(value.normalize('NFC'))]
    .map(segment => segment.segment);
}

export function normalizeWord(value: string, language: LanguageProfile): string {
  return value.trim().normalize('NFC').toLocaleUpperCase(language.locale);
}

export function wordCells(value: string, language: LanguageProfile): string[] | null {
  const cells = graphemes(normalizeWord(value, language), language.locale);
  return cells.length >= 3 && cells.every(cell => language.alphabet.includes(cell)) ? cells : null;
}
